<script setup>
    import { watch, onUnmounted } from 'vue';

    const props = defineProps({
    show: { type: Boolean, required: true },
    loadingText: { type: String, required: false }
    });

  // no scroll when loader is visible
    watch(
        () => props.show,
    (val) => {
      document.body.style.overflow = val ? 'hidden' : '';
        },
        { immediate: true }
    );

    onUnmounted(() => {
    // Cleanup
        document.body.style.overflow = '';
    });
</script>

<template>
  <div v-if="props.show" class="fixed inset-0 bg-[#efede7] flex items-center justify-center z-50">
      <div class="relative">
        <!-- Outer static circle -->
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none" aria-hidden="true">
            <circle cx="26" cy="26" r="24" stroke="#888b8d" stroke-width="4"/>
        </svg>

        <!-- Rotating arc on the border -->
        <svg class="absolute top-0 left-0 arc-spin" xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">
            <circle
            cx="26"
            cy="26"
                r="24"
                stroke="#161412"
                stroke-width="4"
                stroke-linecap="round"
                fill="none"
                stroke-dasharray="150"
            stroke-dashoffset="100"
          />
        </svg>


      </div>

      <p v-if="props.loadingText" class="text-gray-700 font-medium mt-4">{{ props.loadingText }}</p>
    </div>
</template>

<style scoped>
    .arc-spin {
      transform-origin: 50% 50%;
      animation: spin 2s linear infinite;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    @media (prefers-reduced-motion: reduce) {
      .arc-spin {
        animation: none;
      }
    }
</style>
